import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// Layouts
import { FullLayoutComponent } from "@app/layouts/full-layout.component";
import { SimpleLayoutComponent } from "@app/layouts/simple-layout.component";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    component: FullLayoutComponent,
    data: {
      title: "Home",
    },
    children: [
      {
        path: "dashboard",
        loadChildren: "./dashboard/dashboard.module#DashboardModule",
      },
      {
        path: "profilo",
        loadChildren: "./profilo/profilo.module#ProfiloModule",
      },
      {
        path: "gestione-fascicoli",
        loadChildren:
          "./gestione-fascicoli/gestione-fascicoli.module#GestioneFascicoliModule",
      },
      {
        path: "gestione-atti",
        loadChildren:
          "./gestione-atti/gestione-atti.module#GestioneAttiModule",
      },
      {
        path: "gestione-note",
        loadChildren:
          "./gestione-note/gestione-note.module#GestioneNoteModule",
      },
    ],
  },
  {
    path: "pages",
    component: SimpleLayoutComponent,
    data: {
      title: "Pages",
    },
    children: [
      {
        path: "",
        loadChildren: "./pages/pages.module#PagesModule",
      },
    ],
  },
];

@NgModule({
  // imports: [ RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules}) ],
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: "reload" })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
